export default "__VITE_PUBLIC_ASSET__7228567c__"